import { PcnListingResults, PcnListingType } from "pages/pcn/admin/listing/shared";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";


export function PcnAdminOpenListing() {

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: 'SITE_FULL_WIDTH' });
    }, []);


    return (
        <PcnListingResults pcnStateToShow={PcnListingType.OPEN} />
    );

}